import { Helmet } from "react-helmet";
import Header from "../../../../Components/Header";
import CompanyForm from "./CompanyForm";

const ViewCompany = () => {
  return (
    <>
      <div className="d-flex flex-column" style={{ height: '100vh' }}>
      <Helmet>
				<title>Company - View</title>
			</Helmet>
      <Header />
      <div className="container-fluid maindiv d-flex flex-column" style={{flexGrow:'1'}}>
        <CompanyForm />
      </div>
      </div>
     
    </>
  );
};

export default ViewCompany;
